import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';

export class Score extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap'];
  }

  static attributesForModel() {
    return ['score'];
  }

  get title() {
    return 'Score';
  }

  exampleContents(): FieldContentsData {
    return {
      text: 10,
      icon: { name: 'aha-icon aha-icon-product-value-score' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: record.score,
      icon: { name: 'aha-icon aha-icon-product-value-score' },
    };
  }
}
